import { client } from '../config';
import { BulksSvcResponse } from './types/bulksSvc.type';

const getBulksDocumentsList = (
  enterpriseId: string
): Promise<BulksSvcResponse> =>
  client.get(`enterprise/${enterpriseId}/bulk-payment-template/`);

const getBulkDocumentByCountry = async (
  enterpriseId: string,
  country: string,
  language: string,
  providerCode?: string
): Promise<Blob> => {
  const response = await client.get<any, Blob>(
    `enterprise/${enterpriseId}/bulk-payment/${country}/?language=${language}${
      providerCode ? `&providerCode=${providerCode}` : ''
    }`,
    { responseType: 'blob' }
  );
  return response;
};

const BULKS_SVC = {
  getBulksDocumentsList,
  getBulkDocumentByCountry,
};

export default BULKS_SVC;
